export const WARNING_MESSAGE = 'You need credits to book sessions.';